import { render, staticRenderFns } from "./pricinglist.vue?vue&type=template&id=517c4d4e&scoped=true"
import script from "./pricinglist.vue?vue&type=script&lang=js"
export * from "./pricinglist.vue?vue&type=script&lang=js"
import style0 from "./pricinglist.vue?vue&type=style&index=0&id=517c4d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c4d4e",
  null
  
)

export default component.exports